import Utils from '../utils/utils';
import API from './api';
export default class Words {
    static async getWords(query) {
        const responseData = await API.sendRequest(Utils.buildLink(['words'], [`group=${query.group}`, `page=${query.page}`]));
        return responseData;
    }
    static async getWord(id) {
        const responseData = await API.sendRequest(Utils.buildLink(['words', id]));
        return responseData;
    }
}
